// extracted by mini-css-extract-plugin
export var img = "index-module--img--HomUN";
export var root = "index-module--root--hOj+T";